import * as React from "react";

function SvgPortraitIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 35 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M28,1v28H8V1z"
                strokeLinejoin="round"
                strokeWidth="2"
                stroke="currentColor"/>
        </svg>
    );
}

export default SvgPortraitIcon;